import store from "@/store/index";
import { mapState } from "vuex";
import { http } from "@/request/api";

// 尝试将用户在根目录中的store/index.js的vuex的state变量，全部加载到全局变量中
let $mcStoreKey = [];
$mcStoreKey = store.state ? Object.keys(store.state) : [];

const mcStore = {
  data() {
    return {
      abc: "mixin混入成功"
    };
  },
  beforeCreate() {
    // 将vuex方法挂在到$u中
    // 使用方法为：如果要修改vuex的state中的user.name变量为"史诗" => this.$u.vuex('user.name', '史诗')
    // 如果要修改vuex的state的version变量为1.0.1 => this.$u.vuex('version', '1.0.1')
    this.$mc.vuex = (name, value) => {
      store.commit("$mcStore", {
        name,
        value
      });
    };
  },
  computed: {
    // 将vuex的state中的所有变量，解构到全局混入的mixin中
    ...mapState($mcStoreKey)
  },
  methods: {
    download(v) {
      if (v.resourceUrl == "") {
        this.$message({
          message: "资源不存在",
          type: "error"
        });
        return;
      }
      // console.log(v, "downloadxxx");
      var download = new XMLHttpRequest();
      // var URL = v.attachId.replace(
      var URL = v.resourceUrl.replace(
        "https://edulogin.sanyaedu.org",
        "/uploadOrigin"
      );
      download.open("GET", URL, true);
      download.responseType = "blob";
      download.withCredentials = true;

      download.addEventListener(
        "progress",
        function(evt) {
          // console.log(evt, "evtxxxxxxxx");
          if (evt.lengthComputable) {
            let percentComplete = evt.loaded / evt.total;
            // percentage是当前下载进度，可根据自己的需求自行处理
            let percentage = percentComplete * 100;
            // console.log(percentage, "percentage");
          }
        },
        false
      );
      download.onload = function() {
        var url = window.URL.createObjectURL(download.response);
        var a = document.createElement("a");
        a.href = url;
        // var filePath = v.attachId;
        var filePath = v.resourceUrl;
        //获取最后一个.的位置
        var index = filePath.lastIndexOf(".");
        //获取后缀
        var ext = filePath.substr(index + 1);
        a.download = `${v.title}.${ext}`;
        a.click();
        document.body.removeChild(a);
      };
      download.send();

      // 请求接口 ---
      http.downLoadResTip(v.id).then(res => {});
    },
    // downAttendanceTemplate() {
    //   var download = new XMLHttpRequest();
    //   var URL = process.env.URL_CONNECTION + "/wenbo-school/attendance-group/downLoadAttendancePersonExcelTemplate";
    //   download.open("GET", URL, true);
    //   download.responseType = "blob";
    //   download.withCredentials = true;
    //   download.addEventListener(
    //     "progress",
    //     function(evt) {
          
    //     },
    //     false
    //   );
    //   download.onload = function() {
    //     var url = window.URL.createObjectURL(download.response);
    //     var a = document.createElement("a");
    //     a.href = url;
    //     // a.download = "template.xlsl";
    //     a.click();
    //     document.body.removeChild(a);
    //   };
    //   download.send();
    // },
    matchType(suffix) {
      let result = "unknown";
      var typeObj = {
        image: ["png", "jpg", "jpeg", "bmp", "gif"],
        video: ["mp4", "avi"],
        xls: ["xls", "xlsx"],
        ppt: ["ppt"],
        exe: ["exe"],
        pdf: ["pdf"],
        txt: ["txt"],
        doc: ["doc", "docx"],
        zip: ["zip"]
      };
      for (var key in typeObj) {
        if (typeObj[key].includes(suffix)) {
          result = key;
        }
      }

      return result;
    },

    downloadOther(v) {
      if (v.templateUrl == "") {
        this.$message({
          message: "资源不存在",
          type: "error"
        });
        return;
      }
      // console.log(v, "downloadxxx");
      var download = new XMLHttpRequest();
      // var URL = v.attachId.replace(
      var URL = v.templateUrl.replace(
        "https://edulogin.sanyaedu.org",
        "/uploadOrigin"
      );
      download.open("GET", URL, true);
      download.responseType = "blob";
      download.withCredentials = true;

      download.addEventListener(
        "progress",
        function(evt) {
          // console.log(evt, "evtxxxxxxxx");
          if (evt.lengthComputable) {
            let percentComplete = evt.loaded / evt.total;
            // percentage是当前下载进度，可根据自己的需求自行处理
            let percentage = percentComplete * 100;
            // console.log(percentage, "percentage");
          }
        },
        false
      );
      download.onload = function() {
        var url = window.URL.createObjectURL(download.response);
        var a = document.createElement("a");
        a.href = url;
        // var filePath = v.attachId;
        var filePath = v.templateUrl;
        //获取最后一个.的位置
        var index = filePath.lastIndexOf(".");
        //获取后缀
        var ext = filePath.substr(index + 1);
        a.download = `${v.templateName}`;
        a.click();
        document.body.removeChild(a);
      };
      download.send();

      // 请求接口 ---
      http.downLoadResTip(v.id).then(res => {});
    },
    matchType(suffix) {
      let result = "unknown";
      var typeObj = {
        image: ["png", "jpg", "jpeg", "bmp", "gif"],
        video: ["mp4", "avi"],
        xls: ["xls", "xlsx"],
        ppt: ["ppt"],
        exe: ["exe"],
        pdf: ["pdf"],
        txt: ["txt"],
        doc: ["doc", "docx"],
        zip: ["zip"]
      };
      for (var key in typeObj) {
        if (typeObj[key].includes(suffix)) {
          result = key;
        }
      }

      return result;
    },
    onExceeds(files, fileList) {
      this.$notify({
        title: "警告",
        message: "只能上传一个文件",
        type: "warning"
      });
    }
  }
};

export { store, mcStore };



// WEBPACK FOOTER //
// ./src/store/$mc.mixin.js